import React from 'react';
import { Cpu, Settings, Wrench, CheckCircle } from 'lucide-react';
import { services, whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const icons = { Cpu, Settings, Wrench };

const ServiceCard = ({ service }) => {
  const Icon = icons[service.icon];
  const features = service.features;
  return (
    <div
      data-testid={`service-card-${service.id}`}
      className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg hover:border-[#FF6B00] transition-all duration-300 group p-6 flex flex-col"
    >
      <div className="w-16 h-16 bg-[#FF6B00]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#FF6B00]/20 transition-colors">
        <Icon className="text-[#FF6B00]" size={32} />
      </div>
      <h3 className="text-2xl text-white font-bold mb-2">{service.title}</h3>
      <p className="text-gray-400 text-base mb-5">{service.description}</p>
      <ul className="space-y-3 mb-6 flex-1">
        {features.map((f, i) => (
          <li key={i} className="flex items-start gap-3">
            <CheckCircle className="text-[#FF6B00] flex-shrink-0 mt-1" size={18} />
            <span className="text-gray-300 text-sm">{f}</span>
          </li>
        ))}
      </ul>
      <a
        href={whatsappLink(service.whatsapp)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`service-whatsapp-${service.id}`}
        className="w-full bg-[#25D366] text-white py-3.5 rounded-md hover:bg-[#1fb857] transition-colors font-semibold flex items-center justify-center gap-2"
      >
        <WhatsAppIcon className="w-5 h-5" />
        Orçamento no WhatsApp
      </a>
    </div>
  );
};

const ServicesSection = () => (
  <section id="services" className="py-24 bg-[#111111]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-16">
        <span className="text-[#FF6B00] font-bold text-sm uppercase tracking-wider">Nossos Serviços</span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
          Soluções Completas em <span className="text-[#FF6B00]">Injeção Diesel</span>
        </h2>
        <p className="text-gray-400 text-lg max-w-3xl mx-auto">
          Diagnóstico em bancada, orçamento antes do reparo e 90 dias de garantia
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {services.map((s) => <ServiceCard key={s.id} service={s} />)}
      </div>
    </div>
  </section>
);

export default ServicesSection;
